/* Velaine: opbouw zoals Pluffi (productpagina, reviews, winkelwagen) */
(function () {
  'use strict';
  if (window.__plLoaded) return;
  window.__plLoaded = true;

  var nativeFetch = window.fetch.bind(window);
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  function sized(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function api(url, body) {
    var opt = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } };
    return nativeFetch(url, opt).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  /* ================= Winkelwagen ================= */
  var cartEl = $('#pl-cart');
  var ups = [];
  try { ups = JSON.parse(($('#pl-ups-data') || {}).textContent || '[]'); } catch (e) { ups = []; }
  var state = { cart: null, open: false, last: 0 };
  var I_TRASH = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>';
  var I_BAG = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 8h14l-1 12H6z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/><path d="M12 11.5v5M9.5 14h5"/></svg>';

  function bubble(n) {
    $$('.cart-bubble__text-count').forEach(function (e) { e.textContent = n; });
    $$('.cart-bubble').forEach(function (e) { e.style.display = n ? '' : 'none'; });
  }
  function lineHTML(it) {
    var disc = it.final_line_price < it.original_line_price;
    var variant = it.product_has_only_default_variant ? '' : String(it.variant_title || '').replace(/ \/ /g, ', ');
    return '<div class="pl-line" data-key="' + esc(it.key) + '">' +
      '<a class="pl-line__img" href="' + esc(it.url) + '"><img src="' + esc(sized(it.image, 200)) + '" alt="' + esc(it.product_title) + '" width="74" height="85" loading="lazy"></a>' +
      '<div class="pl-line__info"><div class="pl-line__top"><a class="pl-line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
      '<div class="pl-line__price">' + (disc ? '<s>' + money(it.original_line_price) + '</s>' : '') + money(it.final_line_price) + '</div></div>' +
      (variant ? '<div class="pl-line__var">' + esc(variant) + '</div>' : '') +
      (disc ? '<div class="pl-line__note">Bundelkorting toegepast</div>' : '') +
      '<div class="pl-line__qty"><div class="pl-qty"><button type="button" data-q="-1" aria-label="Een minder">&minus;</button><span>' + it.quantity + '</span><button type="button" data-q="1" aria-label="Een meer">+</button></div>' +
      '<button type="button" class="pl-line__del" data-del aria-label="Verwijderen">' + I_TRASH + '</button></div></div></div>';
  }
  function upHTML(p) {
    var av = (p.variants || []).filter(function (v) { return v.available; });
    if (!av.length) return '';
    var sel = (av.length > 1 || av[0].title !== 'Default Title') ? '<select aria-label="Kies een variant">' + av.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('') + '</select>' : '';
    return '<div class="pl-up" data-up="' + p.id + '"><img src="' + esc(av[0].img || p.img) + '" alt="' + esc(p.title) + '" width="70" height="70" loading="lazy"><div class="pl-up__info"><div class="pl-up__t">' + esc(p.title) + '</div><div class="pl-up__p">' + money(p.price) + '</div>' + sel + '</div><button type="button" class="pl-up__add" data-vid="' + av[0].id + '">' + I_BAG + '<span>Toevoegen</span></button></div>';
  }
  function render() {
    var c = state.cart;
    if (!c || !cartEl) return;
    var empty = !c.item_count;
    $('[data-pl-items]', cartEl).innerHTML = c.items.map(lineHTML).join('');
    $('[data-pl-empty]', cartEl).hidden = !empty;
    $('[data-pl-foot]', cartEl).hidden = empty;
    var inCart = c.items.map(function (i) { return i.product_id; });
    var list = ups.filter(function (p) { return inCart.indexOf(p.id) < 0; });
    $('[data-pl-ups]', cartEl).innerHTML = list.map(upHTML).join('');
    $('[data-pl-ups-wrap]', cartEl).hidden = empty || !list.length;
    $('[data-pl-total]', cartEl).textContent = money(c.total_price);
    var d = c.total_discount || 0;
    $('[data-pl-disc-row]', cartEl).hidden = !d;
    $('[data-pl-disc]', cartEl).textContent = '−' + money(d);
    bubble(c.item_count);
  }
  function refresh() {
    state.last = Date.now();
    return api('/cart.js').then(function (c) { state.cart = c; render(); }).catch(function () {});
  }
  function open(force) {
    if (!cartEl) { window.location.href = '/cart'; return; }
    if (!state.open) {
      state.open = true;
      cartEl.classList.add('is-open');
      cartEl.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('pl-lock');
      setTimeout(function () { var x = $('.pl-cart__close', cartEl); if (x) x.focus({ preventScroll: true }); }, 60);
    }
    if (force === true || Date.now() - state.last > 500) refresh();
  }
  function close() {
    if (!cartEl) return;
    state.open = false;
    cartEl.classList.remove('is-open');
    cartEl.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('pl-lock');
  }
  function findItem(k) { return state.cart ? state.cart.items.filter(function (i) { return i.key === k; })[0] : null; }
  function change(key, q) {
    cartEl.classList.add('is-busy');
    api('/cart/change.js', { id: key, quantity: Math.max(0, q) })
      .then(function (c) { state.cart = c; render(); })
      .catch(function () { return refresh(); })
      .then(function () { cartEl.classList.remove('is-busy'); });
  }
  window.PLCart = { open: open, close: close, refresh: refresh };

  if (cartEl) {
    cartEl.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-pl-close]')) { e.preventDefault(); close(); return; }
      var line = t.closest('.pl-line');
      var qb = t.closest('[data-q]');
      if (line && qb) { var it = findItem(line.getAttribute('data-key')); if (it) change(it.key, it.quantity + parseInt(qb.getAttribute('data-q'), 10)); return; }
      if (line && t.closest('[data-del]')) { change(line.getAttribute('data-key'), 0); return; }
      var add = t.closest('.pl-up__add');
      if (add) {
        var card = add.closest('.pl-up');
        var s = $('select', card);
        var vid = s ? s.value : add.getAttribute('data-vid');
        add.disabled = true;
        cartEl.classList.add('is-busy');
        api('/cart/add.js', { items: [{ id: parseInt(vid, 10), quantity: 1 }] })
          .then(refresh).catch(function () {})
          .then(function () { add.disabled = false; cartEl.classList.remove('is-busy'); });
        return;
      }
      var nav = t.closest('[data-pl-nav]');
      if (nav) {
        var tr = $('[data-pl-ups]', cartEl);
        tr.scrollBy({ left: (nav.getAttribute('data-pl-nav') === 'next' ? 1 : -1) * tr.clientWidth * 0.85, behavior: 'smooth' });
      }
    });
    cartEl.addEventListener('change', function (e) {
      var s = e.target.closest('.pl-up select');
      if (!s) return;
      var card = s.closest('.pl-up');
      var p = ups.filter(function (x) { return String(x.id) === card.getAttribute('data-up'); })[0];
      var v = p && p.variants.filter(function (x) { return String(x.id) === s.value; })[0];
      if (v && v.img) $('img', card).src = v.img;
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.open) close(); });

    /* Elke toevoeging aan de winkelwagen (thema, Kaching, upsell) opent deze winkelwagen */
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch(input, init);
      if (/\/cart\/add/.test(url)) p.then(function (r) { if (r.ok) setTimeout(function () { open(true); }, 120); }).catch(function () {});
      return p;
    };
    var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__plUrl = u; return xo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var x = this;
      if (/\/cart\/add/.test(String(x.__plUrl || ''))) x.addEventListener('load', function () { if (x.status < 300) setTimeout(function () { open(true); }, 120); });
      return xs.apply(this, arguments);
    };

    /* Winkelwagen-icoon in de header opent deze winkelwagen */
    window.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('cart-drawer-component .header-actions__action, [data-pl-open-cart]');
      if (!b || /^\/cart/.test(window.location.pathname)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      open(true);
    }, true);
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-drawer-component').then(function () {
        var C = customElements.get('cart-drawer-component');
        if (!C) return;
        ['open', 'showDialog'].forEach(function (m) { if (typeof C.prototype[m] === 'function') C.prototype[m] = function () { open(); }; });
      });
    }
  }

  /* ================= Productpagina ================= */
  function initPdp() {
    /* Label linksboven op de grote foto */
    $$('[data-pl-badge]').forEach(function (b) {
      var g = $('.product-information media-gallery') || $('media-gallery');
      var host = g ? g.parentElement : null;
      if (!host) return;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(b);
      b.hidden = false;
    });

    /* Bezorgdatum (alleen werkdagen) */
    function addWork(d, n) { d = new Date(d.getTime()); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
    function fmt(d) { try { return d.toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, ''); } catch (e) { return d.getDate() + '-' + (d.getMonth() + 1); } }
    $$('[data-pl-delivery]').forEach(function (b) {
      var t = $('[data-pl-delivery-text]', b);
      var tpl = t && t.getAttribute('data-tpl');
      if (!tpl || tpl.indexOf('{van}') < 0) return;
      var now = new Date();
      t.textContent = tpl.replace('{van}', fmt(addWork(now, parseInt(b.getAttribute('data-min'), 10) || 5))).replace('{tot}', fmt(addWork(now, parseInt(b.getAttribute('data-max'), 10) || 10)));
    });

    /* Kleurtegels: sturen de kleur van paar 1 in de Kaching-bundel aan */
    $$('[data-pl-swatches]').forEach(function (sw) {
      var opt = sw.getAttribute('data-option') || 'Kleur';
      var val = $('[data-pl-sw-val]', sw);
      var tiles = $$('.pl-sw__tile', sw);
      var act = tiles.filter(function (t) { return t.classList.contains('is-active'); })[0];
      var current = act ? act.getAttribute('data-value') : '';
      var selQ = 'select.kaching-bundles__bar-variant-select[aria-label="' + opt + '"]';
      function mark(v) {
        current = v;
        tiles.forEach(function (t) { var on = t.getAttribute('data-value') === v; t.classList.toggle('is-active', on); t.setAttribute('aria-checked', on ? 'true' : 'false'); });
        if (val) val.textContent = v;
      }
      function kSel() { var bar = $('.kaching-bundles__bar--selected'); return (bar && $(selQ, bar)) || $(selQ); }
      function push(v, onlyIfEmpty) {
        var s = kSel();
        if (!s) return false;
        if (onlyIfEmpty && s.selectedIndex > 0) { mark(s.options[s.selectedIndex].text.trim()); return true; }
        var o = Array.prototype.filter.call(s.options, function (x) { return x.text.trim() === v; })[0];
        if (o && s.value !== o.value) {
          s.value = o.value;
          s.dispatchEvent(new Event('input', { bubbles: true }));
          s.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }
      tiles.forEach(function (t) { t.addEventListener('click', function () { var v = t.getAttribute('data-value'); mark(v); push(v); }); });
      document.addEventListener('change', function (e) {
        var s = e.target;
        if (!s || !s.matches || !s.matches(selQ) || s !== kSel()) return;
        if (s.selectedIndex > 0) mark(s.options[s.selectedIndex].text.trim());
      });
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.kaching-bundles__bar') && !e.target.closest('select')) setTimeout(function () { push(current, true); }, 120);
      });
      var tries = 0;
      (function wait() { if (push(current, true)) return; if (++tries < 40) setTimeout(wait, 250); })();
    });

    /* Maattabel */
    document.addEventListener('click', function (e) {
      var t = e.target;
      var o = t.closest && t.closest('[data-pl-chart-open]');
      if (o) { var d = $('[data-pl-chart]', o.closest('[data-pl-swatches]') || document); if (d && d.showModal) d.showModal(); return; }
      var d2 = t.closest && t.closest('dialog[data-pl-chart]');
      if (d2 && (t === d2 || t.closest('[data-pl-chart-close]'))) d2.close();
    });

    /* Vaak samen gekocht */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-pl-fbt-add]');
      if (!b) return;
      var card = b.closest('[data-pl-fbt]');
      var idEl = card && $('[data-pl-fbt-id]', card);
      if (!idEl) return;
      var txt = b.textContent;
      b.disabled = true;
      api('/cart/add.js', { items: [{ id: parseInt(idEl.value, 10), quantity: 1 }] })
        .then(function () { b.textContent = 'Toegevoegd ✓'; open(true); setTimeout(function () { b.textContent = txt; b.disabled = false; }, 2500); })
        .catch(function () { b.disabled = false; });
    });

    /* Reviews */
    $$('[data-pl-rev-list]').forEach(function (list) {
      var sec = list.closest('.pl-rev');
      var raw = '';
      try { raw = JSON.parse($('[data-pl-rev-data]', sec).textContent); } catch (e) { return; }
      var R = String(raw || '').split(/\r?\n/).map(function (l) { return l.trim(); })
        .filter(function (l) { return l && l.charAt(0) !== '#'; })
        .map(function (l) { var c = l.split('|').map(function (x) { return x.trim(); }); return { n: c[1] || 'Anoniem', s: Math.max(0, Math.min(5, parseInt(c[2], 10) || 0)), t: c.slice(6).join(' | ') }; })
        .filter(function (r) { return r.t; });
      var star = '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true"><path d="M10 1.5l2.6 5.4 5.9.8-4.3 4.1 1 5.8L10 14.8l-5.2 2.8 1-5.8L1.5 7.7l5.9-.8z"/></svg>';
      var shown = 0, step = parseInt(sec.getAttribute('data-step'), 10) || 8;
      var more = $('[data-pl-rev-more]', sec);
      function stars(n) { var h = ''; for (var i = 1; i <= 5; i++) h += '<span class="' + (i <= n ? 'on' : '') + '">' + star + '</span>'; return h; }
      function show() {
        var h = '';
        R.slice(shown, shown + step).forEach(function (r) {
          h += '<article class="pl-rv"><div class="pl-rv__stars" role="img" aria-label="' + r.s + ' van 5 sterren">' + stars(r.s) + '</div>' +
            '<div class="pl-rv__who"><span class="pl-rv__av">' + esc(r.n.charAt(0).toUpperCase()) + '</span><span class="pl-rv__name">' + esc(r.n) + '</span></div>' +
            '<p class="pl-rv__txt">' + esc(r.t) + '</p></article>';
        });
        list.insertAdjacentHTML('beforeend', h);
        shown += step;
        if (more) more.hidden = shown >= R.length;
      }
      show();
      if (more) more.addEventListener('click', show);
      var lb = $('[data-pl-lb]', sec);
      if (lb) {
        document.body.appendChild(lb);
        sec.addEventListener('click', function (e) { var ph = e.target.closest('[data-full]'); if (ph) { $('img', lb).src = ph.getAttribute('data-full'); lb.hidden = false; } });
        lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('button')) lb.hidden = true; });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') lb.hidden = true; });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPdp); else initPdp();
})();
